import GenericInsurance from "./GenericInsurance";
import FormWizzard from "./FormWizzard";
//import "./../css/normalize.css"
//import "./../css/skeleton.css"

export default class LifeInsurance extends GenericInsurance {
  render() {
    return (
      <div className="App" style={{ width: "100%" }}>
        <h2 style={{ textAlign: "left" }}>Life Insurance</h2>

        <FormWizzard
          payload={this.getPayload()}
          productName="Term Life Insurance"
          amountOptions={[
            "100.000 CHF",
            "200.000 CHF",
            "300.000 CHF",
            "400.000 CHF",
            "500.000 CHF",
          ]}
          durationOptions={[
            "1 year",
            "2 years",
            "3 years",
            "4 years",
            "5 years",
            "6 years",
            "7 years",
            "8 years",
            "9 years",
            "10 years",
          ]}
          onApply={() => this.showLoginDialog()}
          termsAccepted={false}
        ></FormWizzard>
      </div>
    );
  }
}
